<template>
  <v-row>
    <v-col cols="12">
      <ag-grid-vue
        class="ag-theme-alpine"
        style="height: 60vh"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="logins"
        :gridOptions="gridOptions"
        rowSelection="single"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>
    </v-col>

    <v-col cols="12" class="text-right">
      <v-btn
        @click="saveLogins"
        color="dark"
        class="white--text mr-4"
        >Save Logins</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import ActionButtons from "./ActionButtons.vue";
export default {
  name: "WholesalerLogins",
  components: { AgGridVue },
  props: {
    wholesalerLogins: {
      type: Array,
      required: true
    },
    page: {
      type: Object,
      required: true
    },
    accountNumber: {
      type: Number,
      required: true
    },
    refresh: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    columnDefs: [],
    gridApi: null,
    gridColumnApi: null,
    gridOptions: {},
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true
    },
    logins: {},
    origData: {}
  }),
  beforeMount() {
    const vm = this;

    vm.columnDefs = [
      { headerName: "E-mail", field: "email" },
      {
        headerName: 'CC',
        field: 'cc',
 
        cellRenderer: function(params) {
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.checked = params.value;
          input.addEventListener('click', function(event) {
            params.value = !params.value;
            params.node.data.cc = params.value;
          });
          return input;
        },
      },
      {
        headerName: "Action",
        field: "id",
        width: "64px",
        sortable: false,
        filter: false,
        headerClass: "ag-right-aligned-header",
        cellRendererFramework: ActionButtons,
        cellRendererParams: {
          delete(data) {
            vm.$emit("delete", data);
          }
        }
      }
    ];
    vm.logins = vm.wholesalerLogins;
  },
  mounted() {
    let vm = this;
    vm.gridApi = this.gridOptions.api;
    vm.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    saveLogins() {
      let vm = this;
      var payload = vm.logins.map(e=>{
        return {
          id: e.id,
          email: e.email,
          cc: e.cc
        } 
      })
      vm.updateWholesalerCc({logins: payload})
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      args.api.sizeColumnsToFit();
    },
    onRowSelected(row) {
      const vm = this;
      vm.$emit(`selectRow`, row.data);
    }
  },
  watch: {
    refresh() {
      const vm = this;
      vm.getWholesalerLogins();
    }
  },
};
</script>

<style lang="scss" scoped></style>
